"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ELEVENLABS_CONFIG = void 0;
/**
 * ElevenLabs TTS configuration constants
 * Shared between frontend and backend
 */
exports.ELEVENLABS_CONFIG = {
    MODEL_ID: 'eleven_multilingual_v2',
    OUTPUT_FORMAT: 'pcm_16000',
    AUDIO_CONTENT_TYPE: 'audio/pcm',
};
